import { SocialMediaShares } from "@authory-packages/core";
import { useState } from "react";
import { useWindowSize } from "../../hooks/useWindowSize";
import { SidebarLayoutShowDesktop } from "../../layout/SideBarLayout/SidebarLayout.styles";
import { theme } from "../../theme/theme";
import { formatNumber } from "../../utils/largeNumberFormatting";
import { V3IconFacebook, V3IconHelpCircle, V3IconPinterest, V3IconTwitter } from "../Icons";
import { LearnMoreCTA } from "../ReusableStyledComponents/LearnMoreCTA";
import { V3CaptionGrey35 } from "../ReusableStyledComponents/V3CaptionGrey35";
import { V3Tooltip } from "../Tooltip";
import { V3HeadlineH5 } from "../Typography";
import { V3ModalBase } from "../V3ModalBase";
import { ShareReportMobile } from "./V3ShareReportMobile";
import {
    ReportMobileContent,
    ReportSeparator,
    SCRCountElem,
    SOCIAL_BAR_BR,
    SRDCaptionWrapper,
    SRDContent,
    SRDWrapper,
    SharesReportCaption
} from "./V3SharesReportDesktop.styles";
interface V3SharesReportDesktopProps {
    shares: SocialMediaShares;
}

export const V3SharesReportDesktop = ({ shares }: V3SharesReportDesktopProps) => {
    const [modalOpen, setModalOpen] = useState(false);
    const size = useWindowSize();
    const IS_MOBILE = (size.width && size.width < theme.v3.layout.sidebarLayout.mobile) || false;
    const placement = size.width && size.width < SOCIAL_BAR_BR ? "top" : "left";

    return (
        <SRDWrapper
            onClick={() => {
                if (IS_MOBILE && !modalOpen) setModalOpen(true);
            }}
        >
            <SRDContent>
                <SRDCaptionWrapper>
                    <div>
                        <V3CaptionGrey35>
                            <strong>{formatNumber(shares.sum)} Total</strong>
                        </V3CaptionGrey35>
                    </div>
                    <div>
                        <SidebarLayoutShowDesktop>
                            <V3Tooltip
                                referenceContent={<V3IconHelpCircle />}
                                tooltipMaxWidth={285}
                                tooltipContent={
                                    <>
                                        This is how often the original content item has been shared on social media.{" "}
                                        <LearnMoreCTA href="https://authory.com/help/en/articles/6358522-how-does-analytics-work" />
                                    </>
                                }
                                placement="bottom"
                            />
                        </SidebarLayoutShowDesktop>
                    </div>
                </SRDCaptionWrapper>
                <SCRCountElem>
                    <div>
                        <V3Tooltip
                            referenceContent={<V3IconTwitter />}
                            tooltipContent={
                                <>
                                    {!shares.twitter ? (
                                        <SharesReportCaption>No metrics avaliable</SharesReportCaption>
                                    ) : (
                                        <SharesReportCaption>{`${formatNumber(shares.twitter)} Tweets`}</SharesReportCaption>
                                    )}
                                </>
                            }
                            placement={placement}
                        />
                    </div>
                    <div>
                        <V3CaptionGrey35 as="p">{formatNumber(shares.twitter)}</V3CaptionGrey35>
                    </div>
                </SCRCountElem>
                <SCRCountElem>
                    <div>
                        <V3Tooltip
                            referenceContent={<V3IconFacebook />}
                            tooltipContent={
                                <>
                                    {!shares.facebook ? (
                                        <SharesReportCaption>No metrics avaliable</SharesReportCaption>
                                    ) : (
                                        <>
                                            <SharesReportCaption>{`${formatNumber(shares.facebook_comments)} Comments`}</SharesReportCaption>
                                            <SharesReportCaption>{`${formatNumber(shares.facebook_reactions)} Reactions`}</SharesReportCaption>
                                            <SharesReportCaption>{`${formatNumber(shares.facebook_shares)} Shares`}</SharesReportCaption>
                                        </>
                                    )}
                                </>
                            }
                            placement={placement}
                        />
                    </div>
                    <div>
                        <V3CaptionGrey35 as="p">{formatNumber(shares.facebook)}</V3CaptionGrey35>
                    </div>
                </SCRCountElem>
                <SCRCountElem>
                    <div>
                        <V3Tooltip
                            referenceContent={<V3IconPinterest />}
                            tooltipContent={
                                <>
                                    {!shares.pinterest ? (
                                        <SharesReportCaption>No metrics avaliable</SharesReportCaption>
                                    ) : (
                                        <SharesReportCaption>{`${formatNumber(shares.pinterest)} Pins`}</SharesReportCaption>
                                    )}
                                </>
                            }
                            placement={placement}
                        />
                    </div>
                    <div>
                        <V3CaptionGrey35 as="p">{formatNumber(shares.pinterest)}</V3CaptionGrey35>
                    </div>
                </SCRCountElem>
            </SRDContent>
            {modalOpen && (
                <V3ModalBase
                    isOpen={modalOpen}
                    onClose={() => {
                        setModalOpen(false);
                    }}
                    title="Social media shares"
                >
                    <ReportMobileContent>
                        <div></div>
                        <div>
                            <V3HeadlineH5>Total</V3HeadlineH5>
                        </div>
                        <div>
                            <V3HeadlineH5>
                                <strong>{formatNumber(shares.sum)}</strong>
                            </V3HeadlineH5>
                        </div>
                    </ReportMobileContent>
                    <ReportSeparator />
                    <ShareReportMobile icon={<V3IconTwitter />} label="Twitter" number={shares.twitter} />
                    <ShareReportMobile icon={<V3IconFacebook />} label="Facebook" number={shares.facebook} />
                    <ShareReportMobile label="Comments" number={shares.facebook_comments} isMain={false} />
                    <ShareReportMobile label="Reactions" number={shares.facebook_reactions} isMain={false} />
                    <ShareReportMobile label="Shares" number={shares.facebook_shares} isMain={false} />
                    <ShareReportMobile icon={<V3IconPinterest />} label="Pinterest" number={shares.pinterest} />
                </V3ModalBase>
            )}
        </SRDWrapper>
    );
};
